import useTranslation from "../../../hooks/i18n/useTranslation";
import { ROUTE_TYPES } from "../../../classes/constants/routeConstants";
import IconsEnum from "../../../classes/enums/IconsEnum";
import { SurgerySidebarCategories } from "../../../classes/enums/SurgicalActsEnum";
import { ToolShape } from "../../../classes/enums/ToolsEnum";
import ToolBar from "../../common/toolBar/ToolBar";
import ToolToggle from "../../common/toolBar/ToolToggle";

/**
 * Toolbar component for Check module
 * Displays SPP toggle and main toolbar with various tools
 */
const CheckToolbar = ({
  controlsDisabled,
  isCurrentModalityCtOrMr,
  isCurrentModalityCt,
  hasTwinCtInstance,
  isFusionApplicable,
  hasTwin3dCapability,
  is3dViewActive,
  isRadioDensityActive,
  isDataFusionActive,
  activeSidebar,
  onSppToggle,
  onView3dToggle,
  onRadioDensityToggle,
  onDataFusionToggle,
}) => {
  const { t } = useTranslation();

  const sideBarTools = () => {
    return (
      <div className="Visualization-region-tools-side">
        <ToolToggle
          text={t("409")}
          icon={IconsEnum.SPP}
          isSelected={activeSidebar === SurgerySidebarCategories.spp}
          onClick={onSppToggle}
          shape={ToolShape.SQUARE}
          disabled={controlsDisabled || isCurrentModalityCtOrMr}
        />
      </div>
    );
  };

  return (
    <div
      className="Visualization-region-tools"
      style={
        controlsDisabled ? { pointerEvents: "none", opacity: 0.5 } : undefined
      }
    >
      {sideBarTools()}
      <ToolBar
        step={ROUTE_TYPES.CHECK}
        checkToolsState={{
          threeDView: {
            has3dInstances: hasTwin3dCapability && isCurrentModalityCtOrMr,
            is3dViewActive: is3dViewActive,
            onView3dToggle: onView3dToggle,
          },

          radioDensity: {
            hasRadioDensity: hasTwinCtInstance && isCurrentModalityCt,
            isRadioDensityActive: isRadioDensityActive,
            onRadioDensityToggle: onRadioDensityToggle,
          },

          measurementsState: {
            canMeasure: !isCurrentModalityCtOrMr,
          },
        }}
        sharedToolsState={{
          dataFusion: {
            hasDataFusion: isFusionApplicable && !isCurrentModalityCtOrMr,
            isDataFusionActive: isDataFusionActive,
            onDataFusionToggle: onDataFusionToggle,
          },
        }}
      />
    </div>
  );
};

export default CheckToolbar;
